import React, { useState, useEffect } from "react";
import "../css/others/Popup.css";
import ToastPopup from "./ToastPopup";
import { Props } from '../interFaces/interfaces';
import { apiCall } from "../main/ApiCall";
import { TimezoneOption, createToastMessage, ToastMessage } from "../interFaces/interfaces";
const RescheduleMeetingPopup: React.FC<Props> = ({ handleClose, handleSubmit, campaignDetails }) => {
  const [fromDateTime, setFromDateTime] = useState("");
  const [toDateTime, setToDateTime] = useState("");
  const [timezone, setTimezone] = useState("");
  const [attendees, setAttendees] = useState<string[]>([""]);
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [timezoneOptions, setTimezoneOptions] = useState<TimezoneOption[]>([]);
  const [loadingTimezones, setLoadingTimezones] = useState(true);
  const userEmail = localStorage.getItem("email");
  useEffect(() => {
    const fetchTimezones = async () => {
      try {
        const response = await apiCall("get", "/api/timezones");
        setTimezoneOptions(response);
      } catch (error) {
        setMessage(createToastMessage("Failed to load timezones", "error", 3000));
      } finally {
        setLoadingTimezones(false);
      }
    };
    fetchTimezones();
    if (!campaignDetails) return;
    const extractEmails = (obj: any): string[] => {
      const emails: string[] = [];
      const checkForEmail = (value: any) => {
        if (typeof value === 'string' && value.includes('@')) {
          emails.push(value);
        } else if (typeof value === 'object' && value !== null) {
          Object.values(value).forEach(checkForEmail);
        }
      };
      Object.values(obj).forEach(checkForEmail);
      return [...new Set(emails)];
    };
    const extractedEmails = extractEmails(campaignDetails);
    if (extractedEmails.length > 0) {
      setAttendees([...extractedEmails, ""]);
    }
  }, [campaignDetails]);
  const formatDateTimeForAPI = (dateTime: string, timezone: string) => {
    if (!dateTime) return "";
    const date = new Date(dateTime);
    const timezoneOffset = date.getTimezoneOffset();
    const offsetHours = Math.abs(Math.floor(timezoneOffset / 60)).toString().padStart(2, '0');
    const offsetMinutes = Math.abs(timezoneOffset % 60).toString().padStart(2, '0');
    const offsetSign = timezoneOffset > 0 ? '-' : '+';
    return `${date.toISOString().split('.')[0]}${offsetSign}${offsetHours}:${offsetMinutes}[${timezone}]`;
  };
  const handleAttendeeChange = (index: number, value: string) => {
    const updated = [...attendees];
    updated[index] = value;
    setAttendees(updated);
  };
  const addAttendee = () => {
    setAttendees([...attendees, ""]);
  };
  const removeAttendee = (index: number) => {
    const updated = attendees.filter((_, i) => i !== index);
    setAttendees(updated.length ? updated : [""]);
  };
  const onSubmit = () => {
    if (!timezone || !fromDateTime || !toDateTime) {
      setMessage(createToastMessage("Please fill in all required fields: Timezone, From, and To datetime.", "warning", 3000));
      return;
    }
    const validAttendees = attendees.filter(email => email.trim() !== "");
    if (validAttendees.length === 0) {
      setMessage(createToastMessage("Please enter at least one attendee email.", "warning", 3000));
      return;
    }
    const data = {
      eventId: campaignDetails?.eventId,
      newStartTime: formatDateTimeForAPI(fromDateTime, timezone),
      newEndTime: formatDateTimeForAPI(toDateTime, timezone),
      timezone,
      updatedAttendees: validAttendees,
      sendUpdates: "all",
      rescheduledBy: userEmail,
    };
    handleSubmit(data);
  };
  return (
    <>
      <div className="reschedule-popup-overlay">
        <div className="reschedule-popup">
          <h3>Reschedule Meeting</h3>
          <div className="reschedule-popup-scrollable">
            <label>Timezone</label>
            <select value={timezone} onChange={(e) => setTimezone(e.target.value)}>
              <option value="">-- Select Timezone --</option>
              {loadingTimezones ? (
                <option disabled>Loading timezones...</option>
              ) : (
                timezoneOptions.map(tz => (
                  <option key={tz.id} value={tz.id}>
                    {tz.id} ({tz.abbreviation}, {tz.offset})
                  </option>
                ))
              )}
            </select>
            <label>New Proposed Date & Time - From</label>
            <input type="datetime-local" value={fromDateTime} onChange={(e) => setFromDateTime(e.target.value)} />
            <label>New Proposed Date & Time - To</label>
            <input type="datetime-local" value={toDateTime} onChange={(e) => setToDateTime(e.target.value)} />
            <label>Attendees (Emails)  <button className="action-button" type="button" onClick={addAttendee}>Add Attendees</button></label>
            {attendees.map((email, index) => (
              <div key={index} className="attendee-row">
                <input type="email" placeholder="Enter attendee email" value={email} onChange={(e) => handleAttendeeChange(index, e.target.value)} className="attendee-input" />
                {index < attendees.length - 1 || attendees.length > 1 ? (
                  <button className="action-button attendee-remove-btn" type="button" onClick={() => removeAttendee(index)}>❌</button>
                ) : null}
              </div>
            ))}
          </div>
          <div className="buttons">
            <button className="cancelbutton1" onClick={handleClose}>Cancel</button>
            <button className="savebutton1" onClick={onSubmit}>Submit</button>
          </div>
        </div>
      </div>
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </>
  );
};
export default RescheduleMeetingPopup;